import { gql } from '@apollo/client';

export const COURSES_QUERY = gql`
    query courses {
        courses(useSegmentationFilter: false) {
            edges {
                node {
                    id
                    locales {
                        locale
                        name
                        description
                    }
                    ratingAverage
                    ratingCount
                    tagIds
                    thumbnailImage {
                        id
                        url
                        __typename
                    }
                    heroImage {
                        id
                        url
                        __typename
                    }
                    learningObjects {
                        totalCount
                        edges {
                            node {
                                id
                                duration
                            }
                        }
                    }
                    brandIds
                    createdAt
                    updatedAt
                    __typename
                }
                __typename
            }
            __typename
        }
    }
`;
